export default {
  appTitle: 'Borrower Portal - Local',
  apiUrl: 'https://localhost:8015/api',
  appEnv: 'development',
  p2enabled: false,
  useMockServices: false,
};
